import type { NextVerdict } from './course-sequence';

/** Long enough to read the title and cancel, short enough not to annoy. */
export const UP_NEXT_COUNTDOWN_SECONDS = 5;

export type UpNextPlan =
  | { variant: 'countdown'; seconds: number }
  | { variant: 'play' }
  | { variant: 'quiz' }
  | { variant: 'locked' }
  | { variant: 'end' };

/**
 * What to show when a lesson finishes.
 *
 * Auto-advance is deliberately narrow: lesson -> lesson only, and only when the
 * learner left autoplay on. Landing ON a chapter quiz needs a decision, not a
 * countdown, and a drip-locked next lesson needs a date rather than a spinner.
 *
 * An ARTICLE gets no overlay. It has no adapter, and the only `ended` it fires
 * is the read-to-the-end completion (when manual completion is switched off),
 * so the page shows a persistent "Next lesson" button under the reading pane
 * instead.
 */
export function decideUpNext({
  next,
  autoplayOn,
  sourceKind,
}: {
  next: NextVerdict;
  autoplayOn: boolean;
  sourceKind: 'video' | 'iframe' | 'article';
}): UpNextPlan | null {
  if (sourceKind === 'article') return null;
  switch (next.kind) {
    case 'lesson':
      return autoplayOn
        ? { variant: 'countdown', seconds: UP_NEXT_COUNTDOWN_SECONDS }
        : { variant: 'play' };
    case 'quiz':
      return { variant: 'quiz' };
    case 'locked':
      return { variant: 'locked' };
    default:
      return { variant: 'end' };
  }
}
